<script>
import { mapGetters } from 'vuex'
import ListCompetitor from '@components/list-competitor'

export default {
    components: {
        ListCompetitor,
    },
    props: {
        session: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters('session', ['pastCompetitors']),
    },
}
</script>

<template>
    <BaseContainer>
        <div v-if="pastCompetitors.length">
            <ListCompetitor
                v-for="(competitor, key) in pastCompetitors"
                :key="`competitor${key}`"
                :competitor="competitor"
                :rank="key + 1"
                :odd="key % 2 === 0"
                :qualified="
                    parseInt(competitor.status) === 1 &&
                        competitor.time !== null &&
                        ((session.qualified_mode === 'no-faults' && competitor.totalFaults === 0) ||
                            (session.qualified_mode === 'x-first' && key < session.qualified_count))
                "
            />
        </div>
        <BaseEmpty v-else>
            {{ $t('no-competitor') }}
            <template #description>
                {{ $t('after-all-passage') }}.
            </template>
        </BaseEmpty>
    </BaseContainer>
</template>
